import * as React from 'react';
import axios from 'axios';
import { Modal, Form, Input, Select, Button, Space } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import DatePicker from './DatePicker';

const { Option } = Select;

type ModalProps = {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  singleStudent?: boolean;
  multiStudent?: boolean;
  student?: any;
};

export default function CertificateModal(props: ModalProps) {
  const [students, setStudents] = React.useState([]);

  React.useEffect(() => {
    // Get all the students
    axios.get('/api/student').then((res) => {
      setStudents(res.data);
    });
  });

  const onSingleFinish = (values: any) => {
    axios
      .post(`/api/student/${props.student._id}/certificate`, {
        certificate: values,
      })
      .then((res) => {
        window.location.href = `/student/${props.student._id}`;
      });
    props.onOk();
  };

  const onSingleFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const onMultiFinish = (values: any) => {
    console.log('Success:', values);

    if (values.students.length > 0) {
      values.students.forEach((student: any) => {
        axios
          .post(`/api/student/${student.student}/certificate`, {
            certificate: {
              certificateName: values.certificateName,
              expiryDate: values.expiryDate,
              certificateNumber: student.certificateNumber,
            },
          })
          .then((res) => {
            console.log('certificate added', res.data);
            window.location.href = `/`;
          });
      });

      props.onOk();
    } else {
      props.onCancel();
    }
  };

  const onMultiFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      {props.singleStudent && props.student ? (
        <Modal
          title={`Assign Certificate to ${props?.student?.firstName} ${props?.student?.lastName}`}
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          className="certificate-modal"
          footer={[]}
        >
          <Form
            name="singleStudentCertificate"
            onFinish={onSingleFinish}
            onFinishFailed={onSingleFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Certificate Name"
              name="certificateName"
              rules={[{ required: true, message: 'Please input the certificate name.' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Expiry Date"
              name="expiryDate"
              rules={[{ required: true, message: 'Please add an expiry date.' }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="Certificate Number"
              name="certificateNumber"
              rules={[{ required: true, message: 'Please input the certificate number.' }]}
            >
              <Input />
            </Form.Item>
            <div className="modal-actions">
              <Form.Item>
                <Button type="default" onClick={props.onCancel} className="cancel-create-service-button">
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" className="create-service-button">
                  Add Certificate
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      ) : props.multiStudent ? (
        <Modal
          title="Assign Multiple Certificates"
          visible={props.visible}
          onOk={props.onOk}
          onCancel={props.onCancel}
          className="certificate-modal"
          footer={[]}
        >
          <Form
            name="multiStudentCertificate"
            onFinish={onMultiFinish}
            onFinishFailed={onMultiFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Certificate Name"
              name="certificateName"
              rules={[{ required: true, message: 'Please input the certificate name.' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Expiry Date"
              name="expiryDate"
              rules={[{ required: true, message: 'Please add an expiry date.' }]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.List name="students">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item
                        {...restField}
                        name={[name, 'student']}
                        rules={[{ required: true, message: 'Missing student' }]}
                      >
                        <Select showSearch placeholder="Select a person" optionFilterProp="children">
                          {students.map((student: any) => {
                            return (
                              <Option value={student._id}>
                                {student.firstName} {student.lastName}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'certificateNumber']}
                        rules={[{ required: true, message: 'Missing certificate number' }]}
                      >
                        <Input placeholder="Certificate Number" />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add student
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <div className="modal-actions">
              <Form.Item>
                <Button type="default" onClick={props.onCancel} className="cancel-create-service-button">
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit" className="create-service-button">
                  Add Certificate
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      ) : (
        <Modal title="Error" visible={props.visible} onOk={props.onOk} onCancel={props.onCancel}>
          <p>Something went wrong...</p>
        </Modal>
      )}
    </>
  );
}
